import "./App.css";
import ProgressBar from "./Components/ProgressBar/ProgressBar";
import PetName from "./Components/PetInfoSteps/PetName";
import {
  ChevronDoubleRightIcon,
  ChevronDoubleLeftIcon,
  CheckIcon,
} from "@heroicons/react/solid";
import PetGenderAndBreed from "./Components/PetInfoSteps/PetGenderAndBreed";
import PetAge from "./Components/PetInfoSteps/PetAge";
import { useState, useEffect } from "react";
import PetBodyInfo from "./Components/PetInfoSteps/PetBodyInfo";
import Alert from "./Components/FormAlert/Alert";
import PetAlergic from "./Components/PetInfoSteps/PetAlergic";
import PetFoodSelection from "./Components/PetInfoSteps/PetFoodSelection";
import { calculateService } from "./Services/calculate.service";
import { leftDog, rightDog, buttonDog, ButtonDog, rightCat, leftCat, buttonCat, ButtonCat } from "./assets/svg";
import CalculatedOrder from "./Components/PetInfoSteps/CalculatedOrder";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';



function App() {
  const [step, setStep] = useState(1);
  const [current, setCurrent] = useState(1);
  const [isComplete, setIsComplete] = useState(false);
  const [alert, setAlert] = useState(false);
  const [calculatedData, setCalculatedData] = useState();
  const [animationParent] = useAutoAnimate();
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [isAddingBasket, setIsAddingBasket] = useState(false);
  const [errorAddingBasket, setErrorAddingBasket] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Null");

  const {t} = useTranslation();

  const { petType } = useParams();

  const [petInfo, setPetInfo] = useState({
    id: "",
    step: "",
    name: "",
    breed: "",
    gender: "",
    isNeutral: "",
    birth: { day: "", month: "", year: "" },
    birthDate: "",
    kg: "",
    gr: "",
    activity: "",
    bodyType: "",
    hasAlergic: "",
    allergies: "",
    disease: "",
    hasHealthIssues: "",
    food: [],
    petType: petType
  });

  const [data, setData] = useState({
    id: "",
    animalName: "",
    animalGenus: "",
    gender: "",
    isBarren: "",
    dateOfBirth: "",
    activity: "",
    bodyType: "",
    weight: "",
    foodType: [],
    isAllergy: "",
    allergies: "",
    isDisease: "",
    disease: "",
    isSteps: "",
    petType: ""
  });

  const [preferredOrder, setPreferredOrder] = useState({
    id: "",
    inDelivery: "",
    dateAmount: "",
    isSubscribed: "",
  });

  useEffect(() => {
    setData({
      id: petInfo.id,
      animalName: petInfo.name,
      animalGenus: petInfo.breed,
      gender: petInfo.gender,
      isBarren: petInfo.isNeutral ? petInfo.isNeutral : false,
      dateOfBirth: petInfo.birthDate ? petInfo.birthDate : new Date(),
      weight: petInfo.kg
        ? petInfo.kg < 2
          ? 2
          : petInfo.kg > 46
          ? 46
          : petInfo.kg
        : 0,
      isAllergy: petInfo.hasAlergic ? petInfo.hasAlergic : false,
      allergies: petInfo.allergies ? petInfo.allergies : "",
      isDisease: petInfo.hasHealthIssues ? petInfo.hasHealthIssues : false,
      disease: petInfo.disease ? petInfo.disease : "",
      isSteps: petInfo.step ? petInfo.step : 0,
      activity: petInfo.activity,
      bodyType: petInfo.bodyType,
      foodType: petInfo.food.map((item) => item.value),
      petType: petInfo.petType
    });
  }, [petInfo]);

  const [barSteps, setBarSteps] = useState([
    { name: 1, status: "current" },
    { name: 2, status: "upcoming" },
    { name: 3, status: "upcoming" },
    { name: 4, status: "upcoming" },
    { name: 5, status: "upcoming" },
    { name: 6, status: "upcoming" },
  ]);

  const completeStep = () => {
    if (isComplete) {
      setBarSteps(
        barSteps.map((item, stepIdx) =>
          stepIdx === step - 1
            ? { ...step, name: stepIdx + 1, status: "complete" }
            : stepIdx === step
            ? { ...step, name: stepIdx + 1, status: "current" }
            : item
        )
      );
      setStep(step + 1);
      setCurrent(current + 1);
      setIsComplete(false);
    } else {
      setErrorMessage(t("fillRequiredFields"));
      setAlert(true);
      setTimeout(() => {
        setAlert(false);
        setErrorMessage("Null")
      }, 3000);
    }
  };

  const previousStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  // step bilgileri yollamak için
  const sendStepInfo = async () => {
    const calculate = await calculateService
      .calculeteData(data)
      .then((res) =>
        !petInfo.id ? setPetInfo({ ...petInfo, id: res.data.id }) : null
      );
  };

  //hesaplama yapmak için kullanılan bilgileri yollamak için !!CalculateOrder Sayfasına taşındı
  const sendPetInfo = async () => {
    completeStep();
  };

  // siparişi tamamlamak için gönderilen bilgiler
  const completeOrder = async () => {
    setIsAddingBasket(true);
    const { data } = await calculateService.result(preferredOrder);
    const { gateway } = data;

    window.parent.postMessage({productId: gateway.product, quantity: gateway.quantity, basketId: data.result._id}, "*");

    // In the React app within the iframe
    window.addEventListener('message', (event) => {

      // Access the data from the parent (Shopify website)
      const { addingBasketState } = event.data;

      setErrorMessage(t("basketError"));
        setAlert(true);
        setTimeout(() => {
          setAlert(false);
          setErrorMessage("Null")
      }, 3000);
      
      console.log('Received addingBasketState:', addingBasketState);
    });
    
        
    
    setTimeout(() => {
      setIsAddingBasket(false);
    }, 2000);
  };

  useEffect(() => {
    if (step >= current) {
      setBarSteps(
        barSteps.map((item, stepIdx) =>
          stepIdx === step - 1
            ? { ...step, name: stepIdx + 1, status: "current" }
            : item
        )
      );
    }
    setPetInfo({
      ...petInfo,
      step: step,
    });
    setIsFirstRender(false);
    if (!isFirstRender) {
      sendStepInfo();
    }
  }, [step]);

  return (
      <div className="App h-screen flex-col justify-center items-center relative ">
        {/* <Header /> */}
        <div className="h-20">
          <ProgressBar
            barSteps={barSteps}
            step={step}
            setStep={setStep}
            setIsComplete={setIsComplete}
            isComplete={isComplete}
            petType={petType}
          />
        </div>
        <div
          className="min-h-[200px] mt-3 flex justify-around "
          ref={animationParent}
        >
          {petType == 'dog' ?
              <img
                className="hidden h-8 w-36 self-start mt-16  md:flex  md:h-32 lg:h-36"
                src={leftDog}
                alt="leftDog"
              /> : 
              <img
                className="hidden h-8 w-36 self-start mt-16  md:flex  md:h-32 lg:h-36"
                src={leftCat}
                alt="leftCat"
              />
          }
          
          {(step === 1 && (
            <PetName
              setPetInfo={setPetInfo}
              petInfo={petInfo}
              setIsComplete={setIsComplete}
              petType={petType}
            />
          )) ||
            (step === 2 && (
              <PetGenderAndBreed
                setPetInfo={setPetInfo}
                petInfo={petInfo}
                setIsComplete={setIsComplete}
                petType={petType}
              />
            )) ||
            (step === 3 && (
              <PetAge
                setPetInfo={setPetInfo}
                petInfo={petInfo}
                setIsComplete={setIsComplete}
                petType={petType}
              />
            )) ||
            (step === 4 && (
              <PetBodyInfo
                setPetInfo={setPetInfo}
                petInfo={petInfo}
                setIsComplete={setIsComplete}
                petType={petType}
              />
            )) ||
            (step === 5 && (
              <PetAlergic
                setPetInfo={setPetInfo}
                petInfo={petInfo}
                setIsComplete={setIsComplete}
                petType={petType}
              />
            )) ||
            (step === 6 && (
              <PetFoodSelection
                setPetInfo={setPetInfo}
                petInfo={petInfo}
                setIsComplete={setIsComplete}
                petType={petType}
              />
            )) ||
            (step === 7 && (
              <CalculatedOrder
                petInfo={petInfo}
                calculetedData={calculatedData}
                data={data}
                setPreferredOrder={setPreferredOrder}
                isAddingBasket={isAddingBasket}
                setIsAddingBasket={setIsAddingBasket}
                petType={petType}
              />
            ))}
          {petType == 'dog' ?
              <img
                className="hidden h-8 w-36 self-end mb-16  md:flex  md:h-32 lg:h-[150px]"
                src={rightDog}
                alt="rightDog"
              /> : 
              <img
                className="hidden h-8 w-36 self-end mb-16  md:flex  md:h-32 lg:h-[150px]"
                src={rightCat}
                alt="rightDog"
              />
          }
          
        </div>
        <div className="mt-5 h-fit w-full">
          <Alert alert={alert} setAlert={setAlert} message={errorMessage} />
          <div className="h-20 flex items-center justify-center">
            {step > 1 && (
              <button
                onClick={previousStep}
                type="button"
                className="mr-2 sm:mr-3  inline-flex items-center px-2 py-2 sm:px-4 sm:py-2 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-lime-600 hover:bg-lime-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lime-500"
              >
                <ChevronDoubleLeftIcon
                  className="mr-3 -ml-1 h-5 w-5"
                  aria-hidden="true"
                />
                {t("previousStep")}
              </button>
            )}
            {step < 6 ? (
              <div className="flex items-center mb-2">
                {petType == 'dog' ?
                    <img
                      className="h-10 mr-2 sm:mr-4"
                      src={buttonDog}
                      alt="buttonDog"
                    /> : 
                    <img
                      className="h-10 mr-2 sm:mr-4"
                      src={buttonCat}
                      alt="buttonCat"
                    />
                }
                
                <button
                  onClick={completeStep}
                  type="button"
                  className="inline-flex items-center px-2 py-2 sm:px-4 sm:py-2 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-lime-600 hover:bg-lime-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lime-500"
                >
                  {t("nextStep")}
                  <ChevronDoubleRightIcon
                    className="ml-3 -mr-1 h-5 w-5"
                    aria-hidden="true"
                  />
                </button>
              </div>
            ) : step < 7 ? (
              <div className="flex items-center fresh-calculate">
                {petType == 'dog' ?
                    <img
                      className="h-10 mr-2 sm:mr-4"
                      src={buttonDog}
                      alt="buttonDog"
                    /> : 
                    <img
                      className="h-10 mr-2 sm:mr-4"
                      src={buttonCat}
                      alt="buttonCat"
                    />
                }
                <button
                  onClick={sendPetInfo}
                  type="button"
                  className="inline-flex items-center px-2 py-2 sm:px-4 sm:py-2 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-lime-600 hover:bg-lime-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lime-500 fresh-calculate"
                >
                  {t("calculateMeal")}
                  <CheckIcon className="ml-3 -mr-1 h-5 w-5" aria-hidden="true" />
                </button>
              </div>
            ) : (
              <div className="flex items-center">
                {petType == 'dog' ?
                    <img
                      className="h-10 mr-2 sm:mr-4"
                      src={buttonDog}
                      alt="buttonDog"
                    /> : 
                    <img
                      className="h-10 mr-2 sm:mr-4"
                      src={buttonCat}
                      alt="buttonCat"
                    />
                }
                {/* <ButtonDog className="h-10 mr-2 sm:mr-4 animate-bounce" /> */}
                {isAddingBasket ? (
                  <></>
                ): (
                  <button
                  onClick={completeOrder}
                  type="button"
                  className="inline-flex items-center px-0.5 py-2 sm:px-4 sm:py-2 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-lime-600 hover:bg-lime-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lime-500"
                >
                  {t("completeOrder")}
                  <CheckIcon
                    className="ml-3 -mr-1 h-5 w-5"
                    aria-hidden="true"
                  />
                </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
  );
}

export default App;



